import { render, staticRenderFns } from "./tablejoven.vue?vue&type=template&id=1470f2af&"
import script from "./tablejoven.vue?vue&type=script&lang=js&"
export * from "./tablejoven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports